import React from "react";
import { withStyles } from "@material-ui/styles";
import { get, map, sum } from "lodash";

import Grid from "@material-ui/core/Grid";

import images from "../../../assets/img/images";

const styles = {
  mainBar: {
    height: "14px",
    marginBottom: "5px",
  },
  secondaryBar: {
    height: "8px",
    marginBottom: "5px",
  },
  expandArrow: {
    width: "20px",
    cursor: "pointer",
  },
};

const MdcChartValue = (props) => {
  const { classes, item, barColors, secondLevel, maxValue, language } = props;
  const [expanded, setExpanded] = React.useState(false);

  const total = sum(map(get(item, [secondLevel]), (i) => get(i, ["total"])));

  return (
    <Grid item style={{ marginBottom: "15px" }}>
      <Grid container direction="column" style={{ paddingLeft: "16px" }}>
        <Grid item className="text-87" style={{ marginLeft: "-20px" }}>
          <Grid container alignItems="center">
            <Grid
              item
              className={classes.expandArrow}
              onClick={() => setExpanded(!expanded)}
            >
              <img
                src={expanded ? images.arrowOpenBlack : images.arrowClosedBlack}
                alt="arrow"
              />
            </Grid>
            <Grid item className="bold-500">
              {get(item, ["name"]) || get(item, [`name_${language}`])}
            </Grid>
            <Grid item style={{ marginLeft: "15px" }}>
              {total}
            </Grid>
          </Grid>
        </Grid>
        <Grid
          item
          className={classes.mainBar}
          style={{
            backgroundColor: get(barColors, [0]),
            width: `calc(${Math.round((total / maxValue) * 100)}% - 10px)`,
          }}
        />
        {expanded &&
          map(get(item, [secondLevel]), (i, index) => (
            <React.Fragment key={index}>
              <Grid item className="text-87">
                <Grid container alignItems="center">
                  <Grid item>
                    {get(i, [`name_${language}`]) || get(i, ["name"])}
                  </Grid>
                  <Grid item style={{ marginLeft: "15px" }}>
                    {get(i, ["total"])}
                  </Grid>
                </Grid>
              </Grid>
              <Grid
                item
                className={classes.secondaryBar}
                style={{
                  backgroundColor: get(barColors, [1]),
                  width: `calc(${Math.round(
                    (get(i, ["total"]) / maxValue) * 100
                  )}% - 10px)`,
                  minWidth: "2px",
                }}
              />
            </React.Fragment>
          ))}
      </Grid>
    </Grid>
  );
};

export default withStyles(styles)(MdcChartValue);
